import type {
  VetcanAssistantConfidence,
  VetcanAssistantConfidenceNote,
  VetcanAssistantSourceSummary,
} from "../../lib/vetcanApi";

function notePalette(confidence: VetcanAssistantConfidence) {
  switch (confidence) {
    case "limited":
      return {
        border: "rgba(181, 141, 34, 0.18)",
        background: "rgba(255, 250, 240, 0.95)",
        color: "#6d5210",
      };
    case "not_applicable":
      return {
        border: "rgba(162, 62, 62, 0.18)",
        background: "rgba(255, 244, 241, 0.95)",
        color: "#7c2f2f",
      };
    default:
      return {
        border: "rgba(44, 93, 67, 0.16)",
        background: "rgba(245, 251, 247, 0.95)",
        color: "#224634",
      };
  }
}

export default function StudioKnowledgeAssistantConfidenceNote(props: {
  confidence: VetcanAssistantConfidence;
  note: VetcanAssistantConfidenceNote;
  sourceSummaries: VetcanAssistantSourceSummary[];
}) {
  const palette = notePalette(props.confidence);

  return (
    <section
      aria-label="Studio assistant confidence note"
      style={{
        marginTop: "0.9rem",
        borderRadius: 18,
        border: `1px solid ${palette.border}`,
        background: palette.background,
        padding: "0.85rem 0.95rem",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "0.6rem",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
        }}
      >
        <div style={{ minWidth: 220 }}>
          <div
            style={{
              fontSize: "0.78rem",
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: palette.color,
            }}
          >
            Why this answer
          </div>
          <div
            style={{
              marginTop: "0.35rem",
              fontWeight: 700,
              color: "#2e2823",
            }}
          >
            {props.note.title}
          </div>
          <div
            style={{
              marginTop: "0.28rem",
              lineHeight: 1.6,
              color: "#4d453d",
            }}
          >
            {props.note.detail}
          </div>
        </div>

        {props.sourceSummaries.length > 0 ? (
          <div style={{ minWidth: 220 }}>
            <div
              style={{
                fontSize: "0.78rem",
                fontWeight: 700,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                color: "#6a6056",
              }}
            >
              Source mix
            </div>
            <div
              style={{
                marginTop: "0.45rem",
                display: "flex",
                gap: "0.45rem",
                flexWrap: "wrap",
              }}
            >
              {props.sourceSummaries.map((summary) => (
                <div
                  key={`${summary.label}-${summary.detail}`}
                  style={{
                    borderRadius: 999,
                    border: "1px solid rgba(54, 44, 35, 0.12)",
                    background: "rgba(255, 255, 255, 0.9)",
                    padding: "0.34rem 0.62rem",
                    color: "#3f372f",
                    fontSize: "0.86rem",
                    lineHeight: 1.3,
                  }}
                >
                  <strong>{summary.label}</strong>
                  {` · ${summary.detail}`}
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
}
